import StudySummary from './StudySummary.jsx';

export default StudySummary;
